import apiTypes from 'src/api/optimalprint-sdk.d';
import { Price } from 'src/store/price/types';

const productPriceToPrice = (productPrice: apiTypes.AppBundle.Api.Entity.Product.V1.IProductPrice, perItem = false) => ({
  price: perItem ? productPrice.ip : productPrice.p,
  priceInitial: perItem ? productPrice.ipi : productPrice.pi,
} as Price);

export default productPriceToPrice;
